import { CardFooterController } from './cardFooter.controller';
import template from './cardFooter.html';

export const cardFooterComponent = {
  name: 'cardFooter',
  restrict: 'E',
  template,
  controller: CardFooterController,
  controllerAs: 'vm',
  bindings: {
    states: '<',
    hasError: '<',
    errorFields: '<',
    contractingPartners: '<?',
    errorClick: '&',
    cancelContractClick: '&',
  },
};
